export default class ChatbotAPIs {
  constructor(_api) {
    this.api = _api;
  }

  /**
   * Check chatbot service health
   * @returns {Promise} Health status
   */
  checkHealth = () => {
    return this.api.get("/chatbot/health");
  };

  /**
   * Get chatbot configuration info
   * @returns {Promise} Configuration details
   */
  getInfo = () => {
    return this.api.get("/chatbot/info");
  };

  /**
   * Send message to ChatGPT (Assistants API)
   * @param {string} message - User message
   * @param {string|null} threadId - Thread ID for continuing conversation (optional)
   * @returns {Promise} ChatGPT response with threadId
   */
  sendMessage = (message, threadId = null) => {
    const payload = { message };

    // Include threadId if provided
    if (threadId) {
      payload.threadId = threadId;
    }

    return this.api.post("/chatbot/message", payload);
  };

  /**
   * Create a new conversation thread
   * @returns {Promise} New thread ID
   */
  createThread = () => {
    return this.api.post("/chatbot/thread");
  };

  /**
   * Perform detailed health check
   * @returns {Promise} Detailed health status
   */
  detailedHealthCheck = () => {
    return this.api.get("/chatbot/health/detailed");
  };
}
